module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_06_on.68a04975.svg";